<template>
    <div class="profile-page col-xl-12 col-lg-12 col-md-12 order-2">
        <div class="row">
            <div data-v-71e4f434="" class="col-lg-12">
                <div class="col-12"><h1 class="title-tab-content">تغییر رمز عبور</h1></div>
                <div class="content-section default">
                    <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                        <li v-for="error in errors.all()">{{ error }}</li>
                    </ul>
                    <div class="row content-section-row">
                        <div class="account-box-content">
                            <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                                <img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" />
                            </div>
                            <form @submit.prevent="validateForm" class="form-account">
                                <div class="form-account-title">رمز عبور قبلی</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input class="input-field" type="password" v-model="changePass.OldPassword" v-validate="{required:true,min:4,max:12}" data-vv-as="رمز عبور قبلی"
                                           placeholder="رمز عبور قبلی خود را وارد نمایید">
                                </div>
                                <div class="form-account-title">رمز عبور جدید</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input class="input-field" v-model="changePass.NewPassword" v-validate="{required:true,min:4,max:12}" ref="password" data-vv-as="رمز عبور جدید" type="password"
                                           placeholder="رمز عبور جدید خود را وارد نمایید">
                                </div>
                                <div class="form-account-title">تکرار رمز عبور جدید</div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input class="input-field" v-model="changePass.ReNewPassword" type="password" v-validate="{required:true,min:4,max:12,confirmed: 'password'}" data-vv-as="تکرار رمز عبور جدید"
                                           placeholder="رمز عبور جدید خود را مجددا وارد نمایید">
                                </div>
                                <div class="form-account-row form-account-submit">
                                    <div class="parent-btn">
                                        <button type="submit" class="dk-btn dk-btn-info">
                                            تغییر رمز عبور
                                            <i class="now-ui-icons arrows-1_refresh-69"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return { changePass: {}, isShowSppiner:false }
        },
        beforeMount() {
            createPageTitle('تغییر رمز عبور');
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/Customer/ChangePassword', 'post', JSON.stringify(this.changePass),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.isShowSppiner = false;
                                this.resetForm();
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            resetForm() {
                this.changePass = {};
                this.$validator.reset();
                this.$validator.errors.clear();
            }
        },
    }
</script>

<style scoped>
    .content-section-row {
        justify-content:center;
    }
</style>